import { IUser } from '@nkr/models/user';
import { ISwapCounts } from './models';
import { PillWrapper } from './styles';

interface IProps {
    counts: ISwapCounts,
    tabKey: string,
    subTabKey: string,
    user: IUser
}

const Tabs = (props: IProps) => {
    var counts = props.counts;

    var username = props.user != null ? props.user.username : '';

    return (
        <div className='xtabs' style={{ paddingTop: 0, marginBottom: 10 }}>
            <div className='nav nav-tabs' style={{ marginBottom: 0 }}>
                <li className={props.tabKey == 'TARGET-NEW' ? 'active' : ''}><a href={'/target-new'}><span>TARGETS</span></a></li>
                <li className={props.tabKey == 'SWAPS' ? 'active' : ''}><a href={'/manage-swaps/swaps?status=2'}>SWAPS</a></li>
                <li className={props.tabKey == 'NCS' ? 'active' : ''}><a href={'report/ncs-center-scores'} target='_blank'><span>NCS</span></a></li>
                <li className={props.tabKey == 'HIGH-DECLINES' ? 'active' : ''}><a href={'/high-declines'}>HIGH RISK PATIENTS</a></li>
                <li><a href={'/admin/reports/dash-board/compare-conversion'}><span>DONOR</span></a></li>
                <li><a href={'/report/fcr-report'}><span>FCR</span></a></li>
                <li className={props.tabKey == 'MATCH-OFFER-DEADLINES' ? 'active' : ''}><a href={'/manage-swaps/match-offer-deadlines'}><span>MATCH OFFER DEADLINES</span></a></li>
                <li className={props.tabKey == 'DONOR-CLEARANCE-DEADLINES' ? 'active' : ''}><a href={'/manage-swaps/donor-clearance-deadlines'}><span>DONOR CLEARANCE DEADLINES</span></a></li>
                <li className={props.tabKey == 'PREVIOUS-MATCH-RUNS' ? 'active' : ''}><a href={'/matching/match-run/list/new'}><span>PREVIOUS MATCH RUNS</span></a></li>
            </div>

            {props.subTabKey != '' && (
                <div className='nav nav-tabs' style={{ backgroundColor: '#ddd', paddingTop: 5, paddingLeft: 5 }}>
                    <PillWrapper className={props.subTabKey == 'ALL' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=0'}>
                            <span>ALL ({counts.all})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'STALL' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=1'}>
                            <span>STALL ({counts.stalled})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'OFFER' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=2'}>
                            <span>OFFER ({counts.offers})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'XM' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=3'}>
                            <span>XM ({counts.crossMatching})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'LOG' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=7'}>
                            <span>LOG ({counts.logistics})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'KICKOFF' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=4'}>
                            <span>KICKOFF ({counts.kickoff})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'INPROCESS' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=8'}>
                            <span>IN PROCESS ({counts.inProcess})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'KFLID' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=10'}>
                            <span>NKR/KFL ID ({counts.kflId})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'XPLANTED' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps?status=6'}>
                            <span>XPLANTED ({counts.transplanted})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'SWAPTRACKER' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps/swap-tracker'}>
                            <span>SWAP TRACKER ({counts.oneWayTracker})</span>
                        </a>
                    </PillWrapper>

                    <PillWrapper className={props.subTabKey == 'MOVETRACKER' ? 'active' : ''}>
                        <a href={'/manage-swaps/swaps/move-tracker'}>
                            <span>MOVE TRACKER ({counts.swapTracker})</span>
                        </a>
                    </PillWrapper>

                    {props.subTabKey == 'BROKEN-SWAPS' && (
                        <PillWrapper className={'active'}>
                            <a href={'/manage-swaps/broken-swaps'}>
                                <span>BROKEN SWAPS</span>
                            </a>
                        </PillWrapper>
                    )}

                    {props.subTabKey == 'ENDED-CHAINS' && (
                        <PillWrapper className={'active'}>
                            <a href={'/manage-swaps/ended-chains'}>
                                <span>ENDED CHAINS</span>
                            </a>
                        </PillWrapper>
                    )}
                </div>
            )}
        </div>
    );
}

export default Tabs;
